export default __webpack_public_path__ + "static/media/good-bea.840fe6f4.gif";